module.exports = __webpack_public_path__ + "img/5.8cd4ac1f.png";